import { put, call } from 'redux-saga/effects';
import * as types from './constants';
import { takeLatest } from 'redux-saga/effects';

import { getNotificationService } from 'services/messages';

export function* getMessagesSaga(payload) {
  try {
    const response = yield call(getNotificationService, payload.request);
    if (!response.success) {
      yield put({ type: types.GET_MESSAGES_ERROR, error: response.message });
    } else {
      let { messages } = response;
      yield put({ type: types.GET_MESSAGES_SUCCESS, messages });
    }
  } catch (error) {
    if (typeof error === 'object')
      yield put({ type: types.GET_MESSAGES_ERROR, error: error.message });
    else yield put({ type: types.GET_MESSAGES_ERROR, error });
  }
}

export default function* watchMessages() {
  yield takeLatest(types.GET_MESSAGES, getMessagesSaga);
}
